import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Outer } from './outer/Outer';
import { Layout } from './layout/Layout';
import Loader from '../components/loader';
import ExpandableForm from '../modules/metal-analytics/ExpandableForm';
const Dashboard = lazy(() => import('../modules/dashboard/Dashboard'));
const SignIn = lazy(() => import('../modules/authentication/SignIn'));
const DefaultLayout = lazy(() => import('../layout/DefaultLayout'));
const NotFoundPage = lazy(() => import('../modules/NotFoundPage'));
const AmazonOrder = lazy(() => import('../modules/orders/FBAOrder'));
const FDJOrder = lazy(() => import('../modules/orders/FDJOrder'));
const FDJReport = lazy(() => import('../modules/reports/fdj-reports/FDJReport'));
const FBAReport = lazy(() => import('../modules/reports/fba-reports/FBAReport'));
const ListJewelleryTransfer = lazy(() => import('../modules/jewellery-transfer/ListJewelleryTransfer'));
const FBAReturnOrderReport = lazy(() => import('../modules/reports/fba-reports/FBAReturnReport'));
const FDJReturnOrderReport = lazy(() => import('../modules/reports/fdj-reports/FDJReturnReport'));
const FDJCancelOrderReport = lazy(() => import('../modules/reports/fdj-reports/FDJCancelReport'));
const FDJMonthlyReport = lazy(() => import('../modules/reports/MonthlyReport'));
const CostOfGoodsSoldReport = lazy(() => import('../modules/reports/cost-sold-report/CostOfGoodsSoldReport'));
const ReturnAmazonOrder = lazy(() => import('../modules/orders/FBAReturnOrder'));
const MarkReport = lazy(() => import('../modules/reports/MarkReport'));
const ChangePassword = lazy(() => import('../modules/authentication/ChangePassword'));
const FDJReturnOrder = lazy(() => import('../modules/orders/FDJReturnOrder'));
const ListEmployee = lazy(() => import('../modules/employee/ListEmployee'));
const ListAdjustment = lazy(() => import('../modules/adjustment/ListAdjustment'));
const Settings = lazy(() => import('../modules/settings/Settings'));
const ProductSearch = lazy(() => import('../modules/product-search/ProductSearch'));
const CronLog = lazy(() => import('../modules/corn-log/CronLog'));
const OrderTracking = lazy(() => import('../modules/order-tracking/OrderTracking'));
const Unauthorized = lazy(() => import('../modules/error/Unauthorized'));
const CustomerList = lazy(() => import('../modules/wholesalers/customers/CustomerList'));
const OrderItemList = lazy(() => import('../modules/wholesalers/customers/orders/OrderItemList'));
const CustomerOrderList = lazy(() => import('../modules/wholesalers/customers/orders/OrderList'));
const ProductList = lazy(() => import('../modules/wholesalers/products/ProductList'));
const CatalogueList = lazy(() => import('../modules/catalogue/CatalogueList'));
const FileUpload = lazy(() => import('../modules/catalogue/create/CatalogueFileUpload'));
const CatalogueFlipBook = lazy(() => import('../modules/catalogue/FlipBook'));
const MetalAnalytics = lazy(() => import('../modules/metal-analytics/MetalAnalytics'));
const ForeignProductList = lazy(() => import('../modules/foreign-products/ForeignProductList'));
const PolishReport = lazy(() => import('../modules/metal-analytics/report/PolishReport'));
const OtherReport = lazy(() => import('../modules/metal-analytics/report/OtherReport'));
const PowderReport = lazy(() => import('../modules/metal-analytics/report/PowderReport'));
const CustomerOrderDashboard = lazy(() => import('../modules/wholesalers/dashboard/CustomerOrderDashboard'));
const DirectMonthlyReport = lazy(() => import('../modules/reports/DirectMonthReport'));

export const Template = () => {
  const renderWithSuspense = (Component: React.ComponentType) => (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );

  return (
    <Routes>
      {/* Auth Route */}
      <Route element={<Outer />}>
        <Route path="/" index element={renderWithSuspense(SignIn)} />
      </Route>

      <Route element={renderWithSuspense(DefaultLayout)}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={renderWithSuspense(Dashboard)} />

          <Route path="/order-tracking" element={renderWithSuspense(OrderTracking)} />

          {/* Order Routes */}
          <Route path="/order">
            <Route path="fdj" element={renderWithSuspense(FDJOrder)} />
            <Route path="fdj-return" element={renderWithSuspense(FDJReturnOrder)} />
            <Route path="fba" element={renderWithSuspense(AmazonOrder)} />
            <Route path="fba-return" element={renderWithSuspense(ReturnAmazonOrder)} />
          </Route>

          {/* Direct (FDJ) Reports */}
          <Route path="/report/fdj">
            <Route index element={renderWithSuspense(FDJReport)} />
            <Route path="return-order" element={renderWithSuspense(FDJReturnOrderReport)} />
            <Route path="cancel-order" element={renderWithSuspense(FDJCancelOrderReport)} />
          </Route>

          {/* Remote (Amazon) Reports */}
          <Route path="/report/fba">
            <Route index element={renderWithSuspense(FBAReport)} />
            <Route path="return-order" element={renderWithSuspense(FBAReturnOrderReport)} />
          </Route>

          <Route path="/monthly-report" element={renderWithSuspense(FDJMonthlyReport)} />
          <Route path="/department-monthly-report" element={renderWithSuspense(DirectMonthlyReport)} />
          <Route path="/cost-of-goods-sold" element={renderWithSuspense(CostOfGoodsSoldReport)} />

          {/* Settings */}
          <Route path="/settings" element={renderWithSuspense(Settings)} />
          <Route path="/change-password" element={renderWithSuspense(ChangePassword)} />

          {/* Mark report page for all report */}
          <Route path="/mark-report" element={renderWithSuspense(MarkReport)} />

          {/* Transfer */}
          <Route path="/transfer" element={renderWithSuspense(ListJewelleryTransfer)} />

          {/* Adjustment */}
          <Route path="/adjustment" element={renderWithSuspense(ListAdjustment)} />

          {/* product search */}
          <Route path="/product-search" element={renderWithSuspense(ProductSearch)} />

          {/* cron logs */}
          <Route path="/cron-logs" element={renderWithSuspense(CronLog)} />

          <Route path="/employees" element={renderWithSuspense(ListEmployee)} />

          <Route path="/customers">
            <Route index element={renderWithSuspense(CustomerList)} />
            <Route path=":customerId/orders" element={renderWithSuspense(CustomerOrderList)} />
            <Route path=":customerId/orders/:orderNumber" element={renderWithSuspense(OrderItemList)} />
          </Route>

          <Route path="/wholesalers">
            <Route index element={renderWithSuspense(ProductList)} />
          </Route>

          <Route path="/foreign-products">
            <Route index element={renderWithSuspense(ForeignProductList)} />
          </Route>

          <Route path="/catalogue">
            <Route index element={renderWithSuspense(CatalogueList)} />
            <Route path=":catalogueId" element={renderWithSuspense(FileUpload)} />
            <Route path=":catalogueId/flipbook" element={renderWithSuspense(CatalogueFlipBook)} />
          </Route>

          <Route path="/metal-analytics">
            <Route index element={renderWithSuspense(MetalAnalytics)} />
            <Route path="report/polish" element={renderWithSuspense(PolishReport)} />
            <Route path="report/other" element={renderWithSuspense(OtherReport)} />
            {/* <Route path="report/powder" element={renderWithSuspense(PowderReport)} /> */}
            <Route path="form" element={renderWithSuspense(ExpandableForm)} />
          </Route>

          <Route path="/customer-order-dashboard" element={renderWithSuspense(CustomerOrderDashboard)} />

          <Route path="*" element={renderWithSuspense(NotFoundPage)} />
          <Route path="/unauthorized" element={renderWithSuspense(Unauthorized)} />
        </Route>
      </Route>

      <Route path="/:catalogueId/flipbook" element={renderWithSuspense(CatalogueFlipBook)} />

      {/* Not Found */}
      <Route path="*" element={renderWithSuspense(NotFoundPage)} />
      <Route path="/unauthorized" element={renderWithSuspense(Unauthorized)} />
    </Routes>
  );
};
